import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { environment } from '../../../environments/environment';

export interface SeoData {
  title?: string;
  description?: string;
  keywords?: string;
  robots?: 'index, follow' | 'noindex, nofollow';
  canonical?: string;
}

const DEFAULTS = {
  title: 'CapX Flow — Funding for South African businesses',
  description:
    'CapX Flow helps South African businesses and finance brokers apply for funding and follow where each application stands.',
  robots: 'index, follow' as const,
};

@Injectable({ providedIn: 'root' })
export class SeoService {
  private title = inject(Title);
  private meta = inject(Meta);

  update(data: SeoData = {}): void {
    this.title.setTitle(data.title ?? DEFAULTS.title);
    this.meta.updateTag({ name: 'description', content: data.description ?? DEFAULTS.description });

    // Non-production environments are never indexable regardless of route data.
    const robots = !environment.indexable ? 'noindex, nofollow' : (data.robots ?? DEFAULTS.robots);
    this.meta.updateTag({ name: 'robots', content: robots });

    if (data.keywords) {
      this.meta.updateTag({ name: 'keywords', content: data.keywords });
    }

    if (data.canonical) {
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = data.canonical;
    }
  }

  reset(): void {
    this.update();
  }
}
